import React from "react";
import config from "lib/fr-config";
import { translationIndex } from "lib/translationIndex";
import { withStore } from "store/storeHandler";
import { sendError } from "lib/sentryHelper";
import { getLangType } from "lib/commonUtil";
import PropTypes from "prop-types";

const colorCss = config.css.color;

const OPEN_BRACKET_FOR_REPLACEMENT = "<<";
const CLOSED_BRACKET_FOR_REPLACEMENT = ">>";

const OPEN_BRACKET_FOR_BUTTON = "<@";
const CLOSED_BRACKET_FOR_BUTTON = "@>";
const SEPARATOR_FOR_BUTTON = "|@|";

/**
 * capital var
 */
const CAPITAL_COLOR = "raw";
const CAPITAL_CATEGORY = "raw";
const CAPITAL_LOCATION = "raw";
const CAPITAL_DEFAULT_OBJ = {
  btnCommonContained: "raw",
  btnHeader: "upper",
  btnSelect: "upper",
  btnModal: "upper",
  btnList: "raw",
  btnFollowNum: "raw",
  btnTab: "upper",
  btnPanel: "raw",
  btnPanelToggle: "upper",
  btnForgotPassword: "raw",
  btnSnackbar: "upper",
  btnExitItemDeleteMode: "upper",
  btnFooter: "raw",
  btnViewMore: "raw",

  titleModal: "raw",
  titleSection: "raw",
  titleMembSection: "raw",
  membTableElem: "raw",
  titlePanel: "raw",
  titleImgUpload: "raw",
  titlePageError: "raw",

  wordSexUserInfo: "raw",
  wordSexForScore: "raw",
  wordMembershipPrice: "raw",
  wordMembershipBillingPeriod: "raw",
  wordPlaceholder: "raw",
  wordMembershipDate: "raw",
  btnCategoryDemoForItemDetail: "raw",
  btnBrandDemoForItemDetail: "upper",
  wordNullDate: "raw",
  wordDWImgCaption: "raw",
  msgHooking: "raw",
  wordBadge: "raw",

  msg: "raw"
};

const css = {
  btn: { color: colorCss.colorOfPrimary, cursor: "pointer" }
};

TXT.propTypes = {
  name: PropTypes.string.isRequired,
  input: PropTypes.object,
  textType: PropTypes.oneOf([
    "default",
    "color",
    "category",
    "location",
    "quotes" /** 각국의 문법에 맞는 따옴표로 문장을 감싼다 */
  ]),
  categoryType: PropTypes.oneOf([
    "nameForCatModal",
    "groupName",
    "itemLabelName"
  ]),
  btnFuncObj: PropTypes.object
};

TXT.defaultProps = {
  input: null,
  textType: "default",
  categoryType: null,
  btnFuncObj: {}
};

function TXT(props) {
  const { name, input, textType, categoryType, btnFuncObj } = props;
  const { viewerLocation } = props;

  const getCssStyle = () => {
    if (viewerLocation === "KR") {
      return { wordBreak: "keep-all" };
    }
    return {};
  };

  const isButtonBracketCorrect = text => {
    const numOfOpenBracket = text.split(OPEN_BRACKET_FOR_BUTTON).length;
    const numOfClosedBracket = text.split(CLOSED_BRACKET_FOR_BUTTON).length;
    const numOfSeparator = text.split(SEPARATOR_FOR_BUTTON).length;
    if (
      numOfOpenBracket === numOfClosedBracket &&
      numOfClosedBracket === numOfSeparator
    ) {
      return true;
    } else {
      return false;
    }
  };

  const isReplacementBracketCorrect = text => {
    const numOfOpenBracket = text.split(OPEN_BRACKET_FOR_REPLACEMENT).length;
    const numOfClosedBracket = text.split(
      CLOSED_BRACKET_FOR_REPLACEMENT
    ).length;
    if (numOfOpenBracket === numOfClosedBracket) return true;
    return false;
  };

  const getRawTextFromIndex = () => {
    const langType = getLangType(viewerLocation);

    let index;
    switch (textType) {
      case "category":
        if (
          !translationIndex ||
          !translationIndex.categoryList ||
          !translationIndex.categoryList.data ||
          !translationIndex.categoryList.data[name] ||
          !translationIndex.categoryList.data[name][langType] ||
          translationIndex.categoryList.data[name][langType][categoryType] ===
            undefined
        ) {
          sendError(
            Error(
              `wrong index => category:"${name}",` +
                ` langType:"${langType}",` +
                ` categoryType:"${categoryType}"`
            )
          );
          return { error: true };
        }
        return {
          text: translationIndex.categoryList.data[name][langType][categoryType]
        };
      case "color":
        index = `wordColor_${name}`;
        if (
          !translationIndex ||
          !translationIndex[index] ||
          translationIndex[index].text[langType] === undefined
        ) {
          sendError(
            Error(`wrong index => color:"${name}", langType:"${langType}"`)
          );
          return { error: true };
        }
        return { text: translationIndex[index].text[langType] };

      case "location":
        index = `wordLoc_${name}`;

        if (
          !translationIndex ||
          !translationIndex[index] ||
          translationIndex[index].text[langType] === undefined
        ) {
          sendError(
            Error(`wrong index => location:"${name}", langType:"${langType}"`)
          );
          return { error: true };
        }
        return { text: translationIndex[index].text[langType] };
      case "default":
      default:
        if (
          !translationIndex ||
          !translationIndex[name] ||
          translationIndex[name].text[langType] === undefined
        ) {
          sendError(
            Error(`wrong index => name:"${name}", langType:"${langType}"`)
          );
          return { error: true };
        }
        return {
          text: translationIndex[name].text[langType],
          style: translationIndex[name].style
        };
    }
  };

  const convertIntoHookingTxt = inputText => {
    const removePeriod = inputString => {
      const lastChar = inputString.charAt(inputString.length - 1);
      if (lastChar === "." || lastChar === "。") {
        return inputString.slice(0, -1);
      }
      return inputString;
    };
    let returnTxt = inputText;

    switch (viewerLocation) {
      case "RU":
      case "ES":
        returnTxt = removePeriod(returnTxt);
        returnTxt = `«${returnTxt}»`;
        break;
      case "JP":
      case "CN":
        returnTxt = removePeriod(returnTxt);
        returnTxt = `「${returnTxt}」`;
        break;
      case "DE":
        returnTxt = `„${returnTxt}“`;
        break;
      case "FR":
        returnTxt = `«${returnTxt}»`;
        break;

      case "KR":
      case "US":
      case "GB":
      case "CA":
      case "IT":
      default:
        returnTxt = `"${returnTxt}"`;
        break;
    }
    return returnTxt;
  };

  const sliceBtnTxtAndNormalTxt = inputText => {
    const returnArr = [];

    const inputTxtArr = inputText.split(OPEN_BRACKET_FOR_BUTTON);

    for (let i = 0; i < inputTxtArr.length; i++) {
      const textUnitArr = inputTxtArr[i].split(CLOSED_BRACKET_FOR_BUTTON);

      if (!!textUnitArr[0] && textUnitArr[0].length !== 0) {
        returnArr.push(textUnitArr[0]);
      }
      if (!!textUnitArr[1] && textUnitArr[1].length !== 0) {
        returnArr.push(textUnitArr[1]);
      }
    }

    return returnArr;
  };

  const parseNormalOrButtonText = inputText => {
    const returnArr = [];

    if (!isButtonBracketCorrect(inputText)) {
      sendError(Error(`wrong text(btn bracket) => text:"${inputText}"`));
      return null;
    }

    const slicedTextArr = sliceBtnTxtAndNormalTxt(inputText);

    for (let i = 0; i < slicedTextArr.length; i++) {
      const textUnit = slicedTextArr[i];

      if (textUnit.indexOf(SEPARATOR_FOR_BUTTON) > 0) {
        const [btnText, btnIndex] = textUnit.split(SEPARATOR_FOR_BUTTON);
        returnArr.push({
          type: "button",
          value: btnText,
          func: btnFuncObj[btnIndex]
        });
      } else {
        returnArr.push({
          type: "normal",
          value: textUnit
        });
      }
    }

    return returnArr;
  };

  const getCapitalStyle = () => {
    switch (textType) {
      case "color":
        return CAPITAL_COLOR;
      case "category":
        return CAPITAL_CATEGORY;
      case "location":
        return CAPITAL_LOCATION;
      case "default":
      default:
        const capType = name.split("_")[0];
        return CAPITAL_DEFAULT_OBJ[capType];
    }
  };

  const getCapitalizedText = inputText => {
    const capitalStyle = getCapitalStyle();
    switch (capitalStyle) {
      case "upper":
        return inputText.toUpperCase();
      case "raw":
        return inputText;
      default:
        sendError(
          Error(
            `wrong style => ` +
              `capitalStyle:"${capitalStyle}", ` +
              `name:"${name}"`
          )
        );
        return inputText;
    }
  };

  const sliceReplacementTxtAndNormalTxt = inputText => {
    const returnArr = [];

    const inputTxtArr = inputText.split(OPEN_BRACKET_FOR_REPLACEMENT);

    returnArr.push({ type: "normal", value: inputTxtArr.shift() });

    for (let i = 0; i < inputTxtArr.length; i++) {
      const [replacementText, normalText] = inputTxtArr[i].split(
        CLOSED_BRACKET_FOR_REPLACEMENT
      );

      returnArr.push({ type: "replacement", value: input[replacementText] });

      if (!!normalText && normalText.length !== 0) {
        returnArr.push({ type: "normal", value: normalText });
      }
    }
    return returnArr;
  };

  const getTextContent = textValue => {
    const returnArr = [];

    if (!isReplacementBracketCorrect(textValue)) {
      sendError(
        Error(`wrong text(replacement bracket) => text:"${textValue}"`)
      );
      return null;
    }

    const rawTextArr = sliceReplacementTxtAndNormalTxt(textValue);

    for (let i = 0; i < rawTextArr.length; i++) {
      const { type, value } = rawTextArr[i];
      if (type === "normal") {
        returnArr.push(getCapitalizedText(value));
      } else {
        returnArr.push(<React.Fragment key={`${i}`}>{value}</React.Fragment>);
      }
    }

    return returnArr;
  };

  const getTextObj = () => {
    const returnArr = [];
    let rawText;

    const { text, error } = getRawTextFromIndex();
    if (error) return null;
    rawText = text;

    if (textType === "quotes") {
      rawText = convertIntoHookingTxt(rawText);
    }

    const parsedTextObjList = parseNormalOrButtonText(rawText);

    for (let i = 0; i < parsedTextObjList.length; i++) {
      const { type, value, func } = parsedTextObjList[i];

      if (type === "button") {
        returnArr.push(
          <span key={`${i}btn`} style={css.btn} onClick={func}>
            {getTextContent(value)}
          </span>
        );
      } else {
        returnArr.push(
          <React.Fragment key={`${i}norm`}>
            {getTextContent(value)}
          </React.Fragment>
        );
      }
    }

    return returnArr;
  };

  return <span style={getCssStyle()}>{getTextObj()}</span>;
}

export default withStore({
  stateMap: { userDevice: ["viewerLocation"] }
})(TXT);
